import React, { createContext, useContext, ReactElement, useState } from 'react';
import PaginateResponseImp from '@/interfaces/PaginateResponseImp';
import { AutomatedAccountHookImp } from './interfaces/AutomatedAccountHookImp';

export const pagination: PaginateResponseImp = {
  current: 1,
  pages: 1,
  order: 'asc',
  orderBy: 'costCenterId',
  total: 1,
};

const AutomatedAccountHookContext = createContext<AutomatedAccountHookImp | null>(null);

export const AutomatedAccountHookProvider = ({ children }: { children: ReactElement }) => {
  const [isFeeAdd, setIsFeeAdd] = useState(false);
  const [isAuthorAdd, setIsAuthorAdd] = useState(false);
  const [isAuthorEdit, setIsAuthorEdit] = useState(false);
  const [isInstallmentDescriptionModal, setIsInstallmentDescriptionModal] = useState(false);
  const [isPaymentDescriptionModal, setIsPaymentDescriptionModal] = useState(false);

  return (
    <AutomatedAccountHookContext.Provider
      value={{
        isFeeAdd,
        setIsFeeAdd,
        isAuthorAdd,
        setIsAuthorAdd,
        isAuthorEdit,
        setIsAuthorEdit,
        isPaymentDescriptionModal,
        setIsPaymentDescriptionModal,
        isInstallmentDescriptionModal,
        setIsInstallmentDescriptionModal,
      }}>
      {children}
    </AutomatedAccountHookContext.Provider>
  );
};

const useAutomatedAccount = (): AutomatedAccountHookImp => {
  const context = useContext(AutomatedAccountHookContext);
  if (!context) {
    throw new Error('useAutomatedAccount deve ser usado dentro de um AutomatedAccountHookProvider');
  }

  return context;
};

export default useAutomatedAccount;
